import ItemPartViewState from './ItemPartViewState';

export enum FocusedItemArea {
    Item,
    Oof,
    FossilizedText,
    GlobalReply,
    SeeMore,
}

interface FocusedItemPart {
    itemPart: ItemPartViewState;
    focusedItemArea: FocusedItemArea;
}

export default FocusedItemPart;
